import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Input, Button, Badge, Icon, Form, message, Radio } from 'antd';

import { ExchangeAction } from '../../actions';
import { getExchange } from '../../common/fetch';
import {
    VERIFICATION_TICK_ICON,
    FLAIR_ICON,
    BUILT_DOMAIN_ICON,
    CUSTOM_DOMAIN_ICON
} from '../../config/media';
import { putExchange } from '../../common/fetch';
import { checkUpgrade, checkURL, constructURL, checkRequired } from '../../common/utils';
import { Rive } from '../RiveComponent';
import { DashLinksToolTip } from '../Hosting/Utils';
import { Wrapper } from './style';

const { Item } = Form;

const BUILD_IN_DOMAIN = 'hollaex.cloud';

class ConnectDomain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentScreen: 'domain-select',
            isDomainCheck: false,
            titleVisible: true,
            successStatus: false,
            isLoading: false,
            domain: '',
            url: '',
            domainType: 'built-in-domain',
            havingDomain: false,
            isDisabled: false
        }
    }

    componentDidMount() {
        const { exchange } = this.props;

        if (this.props.biz) {
            this.setData();
        }
        if (exchange && exchange.domain) {
            this.setState({ havingDomain: true });
        }
        if (exchange) {
            this.setState({ isDisabled: checkUpgrade(exchange) });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.biz) !== JSON.stringify(prevProps.biz)
            && this.props.biz.DOMAIN !== prevProps.biz.DOMAIN
            && this.props.biz.URL !== prevProps.biz.url) {
            this.setData();
        }
    }

    setData = () => {
        const { biz, exchange } = this.props;
        let domainType = this.state.domainType;
        if (biz.DOMAIN && biz.URL) {
            if (constructURL(biz.DOMAIN) === `${exchange.name}.${BUILD_IN_DOMAIN}`
                && constructURL(biz.URL) === `api.${exchange.name}.${BUILD_IN_DOMAIN}`) {
                domainType = 'built-in-domain';
            } else {
                domainType = 'custom-domain';
            }
        }
        this.setState({
            domain: biz.DOMAIN ? biz.DOMAIN : this.state.domain,
            url: biz.URL ? biz.URL : this.state.url,
            domainType
        });
    };

    resetData = () => {
        const { biz } = this.props;
        this.setState({
            domain: biz.DOMAIN ? biz.DOMAIN : '',
            url: biz.URL ? biz.URL : '',
            currentScreen: 'domain-select'
        });
    };

    resetStatus = () => {
        this.setState({
            successStatus: false,
            isDomainCheck: false
        });
    }

    handleScreen = (screenType) => {
        this.setState({ currentScreen: screenType });
        if (screenType === 'payment-section'
            || screenType === 'deploy-section'
            || screenType === 'restart-warning'
        ) {
            const width = (screenType === 'payment-section' || screenType === 'deploy-section')
                ? 500
                : 430;
            this.props.handleWidth(width);
            this.setState({ titleVisible: false });
        }
    };

    handleBack = (step) => {
        this.setState({ currentScreen: step })
    }

    handleDomainCheck = async (formProps) => {
        this.setState({ isLoading: true })
        try {
            const { id } = this.props.exchange || {};
            const formValues = {
                id,
                ...formProps,
            };
            let res = await putExchange(formValues);
            this.props.updateBiz({
                DOMAIN: formProps.domain,
                URL: formProps.url
            });
            if (res.data) {
                this.setState({
                    isDomainCheck: true,
                    successStatus: true,
                    isLoading: false
                });
            }
            this.getExchange()
        } catch (err) {
            this.setState({
                isDomainCheck: true,
                isLoading: false,
                successStatus: false
            });
            if (err && err.data) {
                message.error(err.data.message);
            }
        }
    };

    handleDomainName = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handleSubmit = async (callback = () => { }) => {
        localStorage.setItem("isEventStart",true);
        const { domain, url, domainType } = this.state;
        if (domainType === 'custom-domain') {
            callback();
        } else {
            await this.handleDomainCheck({ domain, url });
            callback();
        }
    };

    handleCallback = async () => {
        if (this.props.exchange.is_running) {
            if (this.state.havingDomain) {
                await this.props.handleCloud('updateDomain');
            } else {
                await this.props.handleCloud('restart');
            }
            this.handleScreen('restart-warning');
        } else if (this.props.exchange.is_paid) {
            this.handleScreen('deploy-section');
        } else {
            this.handleScreen('payment-section');
        }
    };

    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });
            this.props.actions.readData(exchange);
        } catch (error) {
            console.error(error);
        }
    };

    handleChange = (e) => {
        if (e === 'custom-domain' || (e && e.target && e.target.value === 'custom-domain')) {
            this.setState({
                domainType: 'custom-domain'
            });
        } else {
            this.setState({
                domainType: 'built-in-domain'
            });
        }
    };

    renderTitle = () => {
        if (this.state.currentScreen === 'domain-select') {
            this.props.handleWidth(500)
            return (
                <div className="main-title">
                    Domain Type
                </div>
            )
        } else if (this.state.currentScreen === 'domain-prerequisite') {
            this.props.handleWidth(500)
            return (
                <div>
                    <Icon
                        type="info-circle"
                        style={{ fontSize: '32px', color: '#00f' }}
                    />
                </div>
            )
        } else {
            this.props.handleWidth(750)
            return (
                <div className="main-title">
                    Connect domain
                </div>
            )
        }
    }

    handleDomain = () => {
        if (this.state.domainType === 'custom-domain') {
            this.handleScreen('domain-prerequisite');
        } else {
            const { exchange } = this.props;
            this.setState({
                domain: `${exchange.name}.${BUILD_IN_DOMAIN}`,
                url: `${exchange.name}.${BUILD_IN_DOMAIN}/api`,
            });
            this.handleScreen('check-domain');
        }
    };

    handleUpgrade = () => {
        this.props.history.push('/billing');
    }

    checkDot = (rule, value, callback) => {
        if (value.length && !value.includes('.')) {
            callback('The format of domain is wrong. e.g. domain.com');
        } else {
            callback();
        }
    };

    checkDomainName = (rule, value, callback) => {
        if (value.length && value === this.state.domain) {
            callback('Must provide a different name from main domain here');
        } else {
            callback();
        }
    };

    handleDNSNext = () => {
        this.handleSubmit(this.handleCallback);
        this.handleScreen('payment-section');
    };

    renderSection = () => {
        const {
            currentScreen,
            isDomainCheck,
            successStatus,
            isLoading,
            domain,
            url,
            domainType = '',
        } = this.state;
        const { getFieldDecorator, validateFields } = this.props.form;
        switch (currentScreen) {
            case 'api-domain':
                return (
                    <div className="container">
                        <div className="title">
                            API domain
                        </div>
                        <div>
                            Enter the your API domain.
                        </div>
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                validateFields((err, values) => {
                                    if (!err) {
                                        this.setState({ url: values.url });
                                        this.handleScreen('DNS-setup');
                                    }
                                });
                            }}
                        >
                            <div className="input-wrapper">
                                <Item>
                                    <div className="main-domain">
                                        Main domain: {domain}
                                    </div>
                                    {getFieldDecorator('url', {
                                        initialValue: constructURL(url),
                                        rules: [
                                            {
                                                validator: checkRequired
                                            },
                                            {
                                                validator: checkURL
                                            },
                                            {
                                                validator: this.checkDot
                                            },
                                            {
                                                validator: this.checkDomainName
                                            },
                                        ]
                                    })(
                                        <Input placeholder="api.example.com" />
                                    )}
                                </Item>
                            </div>
                            <div className='sub-txt'>Need help? Visit the{' '}
                                <a
                                    href="https://forum.hollaex.com/search?q=domain"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    forums.
                                </a>
                            </div>
                            <div className="btn-container">
                                <Button
                                    type="primary"
                                    onClick={() => this.handleBack('main-domain')}
                                >
                                    Back
                                </Button>
                                <div className="separator"></div>
                                <Button
                                    type="primary"
                                    htmlType={'submit'}
                                // onClick={() => this.handleScreen('DNS-setup')}
                                >
                                    Next
                                </Button>
                            </div>
                        </Form>
                    </div>
                )
            case 'DNS-setup':
                const { cloud } = this.props.constant;
                let cloudIpAddress = '';
                let domainName = '';
                if (this.props && this.props.exchange && this.props.exchange.region === 'GB') {
                    cloudIpAddress = (cloud.gp && cloud.gp.ip) || '';
                    domainName = cloud.gp ? `${cloud.gp.cname}.${cloud.gp.domain}` : '';
                } else if (this.props && this.props.exchange && this.props.exchange.region === 'SG') {
                    cloudIpAddress = (cloud.sg && cloud.sg.ip) || '';
                    domainName = cloud.sg ? `${cloud.sg.cname}.${cloud.sg.domain}` : '';
                } else {
                    cloudIpAddress = (cloud.fr && cloud.fr.ip) || '';
                    domainName = cloud.fr ? `${cloud.fr.cname}.${cloud.fr.domain}` : '';
                }
                return (
                    <div className="container">
                        <div className="title">
                            DNS setup
                        </div>
                        <div>
                            Add the following configuration in your DNS provider:
                        </div>
                        <div className="input-wrapper">
                            <div className="box-container">
                                <div className="first-column">{domain}</div>
                                <div className="second-column">{domain.split('.').length === 2 ? 'A RECORD' : 'CNAME'}</div>
                                <div className="third-column">{domain.split('.').length === 2 ? cloudIpAddress : domainName}</div>
                            </div>
                            <div className="chk-btn-container">
                                <Button
                                    type="primary"
                                    onClick={() =>
                                        this.handleDomainCheck({ domain, url })
                                    }
                                >
                                    Check
                                </Button>
                                {
                                    isLoading
                                        ? <span className="space">
                                            <Icon
                                                type="loading"
                                                style={{ fontSize: '1.5rem', color: '#808080' }}
                                            />
                                            <span className="space">
                                                Checking...
                                            </span>
                                        </span>
                                        : null
                                }
                                <div className='sub-txt'>Need help? Visit the{' '}
                                    <a
                                        href="https://forum.hollaex.com/search?q=domain"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        forums.
                                    </a>
                                </div>
                            </div>
                            {isDomainCheck
                                ? successStatus
                                    ? (<div className="status success-status">
                                        <Badge
                                            text="We see it! Proceed by clicking next."
                                            status="success"
                                        >
                                        </Badge>
                                    </div>)
                                    : (<div className="status error-status">
                                        <Badge
                                            text="An error occurred. Go check your DNS setup and try again."
                                            status="error"
                                        >
                                        </Badge>
                                    </div>)
                                : null
                            }
                        </div>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.resetStatus();
                                    this.handleBack('main-domain')
                                }}
                            >
                                Back
                            </Button>
                            <div className="separator"></div>
                            <Button
                                onClick={this.handleDNSNext}
                                type="primary"
                                disabled={isDomainCheck && successStatus ? false : true}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )
            case 'check-domain':
                return (
                    <div className="container">
                        <div className="title">
                            Check {'&'} connect domain
                        </div>
                        <div className='sub-txt'>
                            Everything is in order to finish your domain connection.
                            Please check and confirm that you want to connect this domain
                        </div>
                        <div className="input-wrapper">
                            <div className="box-header">
                                Your new domain info
                            </div>
                            <div className="box-square">
                                <div className="content-space">
                                    <div className='bold-txt'>
                                        Main website:
                                    </div>
                                    <div className='sub-txt'>{domain}</div>
                                    <div className='bold-txt'>
                                        API:
                                    </div>
                                    <div className='sub-txt'>{url}</div>
                                </div>
                            </div>
                        </div>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                onClick={() => {
                                    if (domainType === 'custom-domain') {
                                        this.handleBack('DNS-setup');
                                    } else {
                                        this.handleBack('domain-select');
                                    }
                                }}
                            >
                                Back
                            </Button>
                            <div className="separator"></div>
                            <Button
                                onClick={() => {
                                    this.handleSubmit(this.handleCallback);
                                }}
                                type="primary"
                            >
                                Connect domain
                            </Button>
                        </div>
                    </div>
                )
            case 'payment-section':
                return (
                    <div className="secondary-container payment-wrapper">
                        <Rive src={'updateDomain.riv'} />
                        <div className="contents-wrapper">
                            <div className="content-1">
                                You've successfully connected your domain,
                                however you have a pending bill.
                            </div>
                            <div className="content-2">
                                To begin the cloud exchange deployment you
                                must pay the pending bill.
                            </div>
                        </div>
                        <div>
                            <Button type="primary">
                                <Link to="/billing">Go to Billing</Link>
                            </Button>
                        </div>
                    </div>
                )
            case 'deploy-section':
                return (
                    <div className="secondary-container">
                        <div className="contents-wrapper">
                            <div className="icon-wrapper deploy-icon">
                                <img src={VERIFICATION_TICK_ICON} alt="icon" />
                            </div>
                            <div className="content-1">
                                Domain successfully connected!
                            </div>
                            <div className="content-2">
                                Your exchange's domain has successfully been connected.
                            </div>
                        </div>
                        <div>
                            <Button type="primary">
                                <Link to="/dashboard">Okay</Link>
                            </Button>
                        </div>
                    </div>
                )
            case 'restart-warning':
                return (
                    <div className="warning-container image-wrapper">
                        <Rive src={'updateDomain.riv'} />
                        <div className="warning-title">
                            <div className="title">Domain is being updated...</div>
                        </div>
                        <div className="warning-content">Your exchange is being restarted to apply your new domain. During the restart your exchange will be inaccessible.</div>
                        <div className="warning-content"> Once exchange domain updating has completed you will be sent an email.</div>
                        <div className="btn-container">
                            <Link to="/hosting?tab=4">
                                <Button type="primary">
                                    Go to events
                                </Button>
                            </Link>
                        </div>
                    </div>
                )
            case 'domain-prerequisite':
                return (
                    <div className="warning-container">
                        <div className="warning-title">
                            <div className="title">Custom domain prerequisite</div>
                        </div>
                        <div className="warning-content">If you own a domain and want to connect it to your exchange site you will have to login to your domain name provider and go to the settings and complete the 'domain mapping' process, also known as 'forwarding my domain'. You will then need to enter your domain name details in the next step.</div>
                        <div className='flair-content'>
                            <div className='flair-icon-container'><img src={FLAIR_ICON} alt='flair' className="flair_icon"></img></div>
                            <div className="warning-content ">Lastly, it is highly recommended to use <a href="https://www.cloudflare.com" target="_blank" rel="noopener noreferrer" className="flareunderline">Cloudflare</a> <span><DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=_Q9BWoWZEbs'}/></span> to improve your platforms security and performance.</div>
                        </div>
                        <div className='d-flex custom-info-circle'>
                            <Icon
                                type="info-circle"
                                style={{ fontSize: '18px', color: '#f83e18', margin: '2px 5px 0px 0px' }}
                            />
                            <div>
                                In case you activate Cloudflare, turn on the proxy (the orange cloud option) on Cloudflare only after you have set your domain on the dashboard.
                            </div>
                        </div>
                        <div className="warning-content ">Do you want to proceed?</div>
                        <div className="btn-container d-flex">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.resetData();
                                }}
                            >
                                Back
                            </Button>
                            <div className="separator"></div>
                            <Button
                                type="primary"
                                onClick={() => this.handleScreen('main-domain')}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )
            case 'main-domain':
                return (
                    <div className="container">
                        <div className="title">
                            Main domain
                        </div>
                        <div>
                            Enter the domain name you would like to use with your exchange.
                        </div>
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                validateFields((err, values) => {
                                    if (!err) {
                                        this.setState({ domain: values.domain });
                                        if (values.domain && !url) {
                                            this.setState({ url: `subdomain.${values.domain}` });
                                        }
                                        this.handleScreen('DNS-setup');
                                    }
                                });
                            }}
                        >
                            <div className="input-wrapper">
                                <Item>
                                    {getFieldDecorator('domain', {
                                        initialValue: constructURL(domain),
                                        rules: [
                                            {
                                                validator: checkRequired
                                            },
                                            {
                                                validator: checkURL
                                            },
                                            {
                                                validator: this.checkDot
                                            },
                                        ],
                                    })(
                                        <Input
                                            placeholder="example.com"
                                        />
                                    )}
                                </Item>
                            </div>
                            <div className='sub-txt'>Need help? Visit the{' '}
                                <a
                                    href="https://forum.hollaex.com/search?q=domain"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    forums.
                                </a>
                            </div>
                            <div className="btn-container">
                                <Button
                                    type="primary"
                                    onClick={() => this.handleScreen('domain-prerequisite')}
                                >
                                    Back
                                </Button>
                                <div className="separator"></div>
                                <Button
                                    type="primary"
                                    htmlType={'submit'}
                                >
                                    Next
                                </Button>
                            </div>
                        </Form>
                    </div>
                )
            case 'domain-select':
            default:
                // const { isDisabled } = this.state;
                return (
                    <div className="init-container">
                        <Radio.Group
                            name="domainType"
                            onChange={this.handleChange}
                            value={domainType}
                            className='domain-container'
                        >
                            <div className={domainType !== 'custom-domain' ? "box-wrapper box-border" : " box-wrapper"} onClick={() => this.handleChange('built-in-domain')}>
                                <div style={{ backgroundImage: `url(${BUILT_DOMAIN_ICON})` }} className={domainType !== 'custom-domain' ? "imgcontainer " : " disabled-text imgcontainer"}></div>
                                <Radio value="built-in-domain">
                                    <span className="radio-text">Use built-in domain</span>
                                    <div className="small-text" >
                                        Use a free HollaEx.cloud domain name that requires no setup.
                                    </div>
                                </Radio>
                            </div>
                            <div className={domainType === 'custom-domain' ? "box-wrapper box-border" : " box-wrapper"} onClick={() => this.handleChange('custom-domain')}>
                                <div style={{ backgroundImage: `url(${CUSTOM_DOMAIN_ICON})` }} className={domainType !== 'custom-domain' ? "imgcontainer disabled-text" : "imgcontainer"}></div>
                                <Radio value="custom-domain">
                                    <span className="radio-text">Use custom domain</span>
                                    <div className="small-text">
                                        Use your own custom domain name (requires setup)
                                    </div>
                                </Radio>
                            </div>
                        </Radio.Group>
                        {/* {isDisabled 
                            ? <div className="upgrade-section">
                                <div>
                                    <div className="title-text">
                                        Custom Domain
                                    </div>
                                    <div>
                                        Connect your exchange to your own domain
                                    </div>
                                </div>
                                <div className="btn-wrapper">
                                    <Button type="primary" onClick={this.handleUpgrade} >Upgrade Now</Button>
                                </div>
                            </div>
                            : null
                        } */}
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={this.handleDomain}>Confirm</Button>
                        </div>
                    </div>
                )
        }
    }

    render() {
        const { titleVisible } = this.state;
        return (
            <Wrapper>
                {titleVisible
                    ? (this.renderTitle())
                    : null
                }
                {this.renderSection()}
            </Wrapper>
        )
    }
}

const ConnectDomainContent = Form.create({ name: 'ConnectDomain' })(ConnectDomain);

const mapStateToProps = (state) => {
    return {
        constant: state.constant,
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ExchangeAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectDomainContent);
